// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as UserRoleConfig from "../../../../../configs/UserRoleConfig.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as SendSMSSearchCmp from "./SendSMSSearchCmp.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as SendSmsDataMachine from "../../app/repo/SendSmsDataMachine.bs.js";
import * as TemplateManagerCmp from "./template-manager/TemplateManagerCmp.bs.js";
import * as SendSmsStateMachine from "./SendSmsStateMachine.bs.js";
import * as OpenTemplateManagerCmp from "./template-manager/OpenTemplateManagerCmp.bs.js";
import * as UserAndMessageListView from "./UserAndMessageListView.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function SendSMSPageSelector(Props) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$1[1];
  var initialState_previouslySentMessagesDetails = {
    TAG: /* Loading */0,
    _0: undefined
  };
  var initialState_confirmationModal = {
    modal: /* None */2,
    openModal: false
  };
  var initialState_enableEditTemplate = UserRoleConfig.isUserAllowed(UserRoleConfig.smsTemplateEditRoles, WorkSpaceContext.useWorkSpace(undefined).user_roles);
  var initialState = {
    customerAndPartnerDetails: /* Init */0,
    previouslySentMessagesDetails: initialState_previouslySentMessagesDetails,
    userTypeSelection: /* All */0,
    phoneNumber: "",
    selectUser: 0,
    showSidePanel: false,
    selectedUser: undefined,
    confirmationModal: initialState_confirmationModal,
    resendSmsDetails: undefined,
    currentView: /* SearchView */0,
    enableEditTemplate: initialState_enableEditTemplate
  };
  var match$2 = React.useReducer(SendSmsStateMachine.reducer, initialState);
  var dispatch = match$2[1];
  var state = match$2[0];
  var fetchSmsList = function (phoneNumberOrOrderId) {
    if (phoneNumberOrOrderId !== "") {
      Curry._1(dispatch, {
            TAG: /* PreviouslySentMessagesDetails */1,
            previouslySentMessagesDetails: {
              TAG: /* Loading */0,
              _0: undefined
            }
          });
      return SendSmsDataMachine.fetchSmsList({
                  phone_number: phoneNumberOrOrderId,
                  limit: 20,
                  pagination_token: "0"
                }, country, (function (data) {
                    return Curry._1(dispatch, {
                                TAG: /* PreviouslySentMessagesDetails */1,
                                previouslySentMessagesDetails: {
                                  TAG: /* Live */1,
                                  _0: data
                                }
                              });
                  }), (function (error) {
                    Curry._1(openSnackbar, {
                          TAG: /* Error */1,
                          _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                        });
                    return Curry._1(dispatch, {
                                TAG: /* PreviouslySentMessagesDetails */1,
                                previouslySentMessagesDetails: {
                                  TAG: /* Error */2,
                                  _0: error
                                }
                              });
                  }));
    }
    
  };
  var onSearchClick = function (phoneNumberOrOrderId) {
    var match = FormValidationUtils$Catalyst.validateCRN(phoneNumberOrOrderId);
    var tmp;
    tmp = match.TAG === /* Ok */0 ? "crn" : "phone_number";
    SendSmsDataMachine.fetchSmsUser({
          query: phoneNumberOrOrderId,
          query_type: tmp
        }, country, (function (data) {
            var match = FormValidationUtils$Catalyst.validateCRN(phoneNumberOrOrderId);
            var tmp;
            tmp = match.TAG === /* Ok */0 ? phoneNumberOrOrderId : "N/A";
            var match$1 = FormValidationUtils$Catalyst.validateCRN(phoneNumberOrOrderId);
            var tmp$1;
            tmp$1 = match$1.TAG === /* Ok */0 ? "N/A" : phoneNumberOrOrderId;
            var dummyCustomerAndPartnerDetails_0 = {
              profile: "Unverified",
              name: tmp,
              primary_mobile_number: tmp$1,
              secondary_mobile_number: "N/A"
            };
            var dummyCustomerAndPartnerDetails = {
              hd: dummyCustomerAndPartnerDetails_0,
              tl: /* [] */0
            };
            var match$2 = FormValidationUtils$Catalyst.validateCRN(phoneNumberOrOrderId);
            if (match$2.TAG === /* Ok */0) {
              if (List.length(data) > 0) {
                var phoneNumber = List.nth(data, 0).primary_mobile_number;
                Curry._1(dispatch, {
                      TAG: /* PhoneNumber */3,
                      phoneNumber: phoneNumber
                    });
                fetchSmsList(phoneNumber);
              } else {
                Curry._1(dispatch, {
                      TAG: /* PreviouslySentMessagesDetails */1,
                      previouslySentMessagesDetails: {
                        TAG: /* Live */1,
                        _0: /* [] */0
                      }
                    });
              }
            } else {
              fetchSmsList(phoneNumberOrOrderId);
              Curry._1(dispatch, {
                    TAG: /* PhoneNumber */3,
                    phoneNumber: phoneNumberOrOrderId
                  });
            }
            Curry._1(dispatch, {
                  TAG: /* CustomerAndPartnerDetails */0,
                  customerAndPartnerDetails: List.length(data) > 0 ? ({
                        TAG: /* Live */1,
                        _0: data
                      }) : ({
                        TAG: /* Live */1,
                        _0: dummyCustomerAndPartnerDetails
                      })
                });
            return Curry._1(dispatch, {
                        TAG: /* SetCurrentView */9,
                        currentView: /* SmsDashboard */1
                      });
          }), (function (error) {
            return Curry._1(openSnackbar, {
                        TAG: /* Error */1,
                        _0: "Submission Failed! Error : API link broken. Please Try submitting again"
                      });
          }));
    return Curry._1(dispatch, {
                TAG: /* SelectUser */4,
                selectUser: 0
              });
  };
  var onOpenTemplateManagerClick = function (param) {
    return Curry._1(dispatch, {
                TAG: /* SetCurrentView */9,
                currentView: /* TemplateManagerView */2
              });
  };
  var match$3 = state.currentView;
  var tmp;
  switch (match$3) {
    case /* SearchView */0 :
        var match$4 = state.enableEditTemplate;
        var exit = 0;
        switch (country.TAG | 0) {
          case /* India */1 :
          case /* MY */4 :
              exit = 1;
              break;
          default:
            if (match$4) {
              tmp = React.createElement(Column$Catalyst.make, {
                    children: null,
                    className: "sms-search-bar-dashboard u-flex-align-center"
                  }, React.createElement(SendSMSSearchCmp.make, {
                        onSearchClick: onSearchClick
                      }), React.createElement("p", undefined, "or"), React.createElement(OpenTemplateManagerCmp.make, {
                        onOpenTemplateManagerClick: onOpenTemplateManagerClick
                      }));
            } else {
              exit = 1;
            }
        }
        if (exit === 1) {
          tmp = React.createElement(Column$Catalyst.make, {
                children: React.createElement(SendSMSSearchCmp.make, {
                      onSearchClick: onSearchClick
                    }),
                className: "sms-search-bar-dashboard"
              });
        }
        break;
    case /* SmsDashboard */1 :
        tmp = React.createElement("div", {
              className: "sms-user-and-message-list"
            }, React.createElement(UserAndMessageListView.make, {
                  openSnackbar: openSnackbar,
                  state: state,
                  dispatch: dispatch,
                  handle_search_click: onSearchClick
                }));
        break;
    case /* TemplateManagerView */2 :
        tmp = React.createElement(TemplateManagerCmp.make, {
              openSnackbar: openSnackbar,
              show_sidepanel: state.showSidePanel,
              set_show_sidepanel: (function (showSidePanel) {
                  return Curry._1(dispatch, {
                              TAG: /* ShowSidePanel */6,
                              showSidePanel: showSidePanel
                            });
                })
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, match$1[0], tmp);
}

var make = SendSMSPageSelector;

export {
  make ,
  
}
/* react Not a pure module */
